import { render, staticRenderFns } from "./finishFeeRule.vue?vue&type=template&id=54642862"
import script from "./finishFeeRule.vue?vue&type=script&lang=js"
export * from "./finishFeeRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports